import React from 'react';
import { bool } from 'prop-types';

import classnames from 'classnames';

// Components
import SearchIcon from 'dibs-vg/dist/react/magnifying-glass';

// Styles
import styles from './SearchBar-style.scss';

const SearchButton = ({ hasSearchTerm }) => {
    const buttonClasses = classnames(styles.button, {
        [styles.hasTerm]: hasSearchTerm,
    });

    return (
        <button
            className={buttonClasses}
            type="submit"
            value="Submit"
            data-tn="global-header-search-submit"
        >
            <div className={styles.icon}>
                <SearchIcon />
            </div>
        </button>
    );
};

SearchButton.propTypes = {
    hasSearchTerm: bool,
};

SearchButton.defaultProps = {
    hasSearchTerm: false,
};

export default SearchButton;
